export const commonRegex = {
  name: (): RegExp => new RegExp(/^[aA-zZÀ-ÿ\s]+$/),
  onlyNumbers: (): RegExp => new RegExp(/[\D]/g),
  onlyAlphanumeric: (): RegExp => new RegExp(/^[a-zA-Z0-9]+$/g),
  payRoll: (): RegExp => new RegExp(/([A-Z]{1}\d{8})/g),
};
